import { Award, FileText, MapPin, ShieldCheck } from "lucide-react";
import { TRUST_ITEMS } from "@/lib/site";

const ICONS = { insured: ShieldCheck, quotes: FileText, experience: Award, local: MapPin };

export const TrustBar = () => (
  <section data-testid="trust-bar" aria-label="Why choose us" className="bg-brand text-white">
    <ul className="hero-trust-list container-site grid grid-cols-2 gap-x-4 md:grid-cols-4 md:gap-x-6 md:gap-y-5 md:py-7">
      {TRUST_ITEMS.map((t) => {
        const Icon = ICONS[t.id];
        return (
          <li key={t.id} data-testid={`trust-item-${t.id}`} className="flex items-center gap-2.5 md:gap-3">
            <Icon size={22} strokeWidth={1.75} aria-hidden="true" className="shrink-0" />
            <span className="text-[13px] font-semibold leading-snug md:text-[15px]">{t.label}</span>
          </li>
        );
      })}
    </ul>
  </section>
);
